import { useNavigate } from 'react-router';
import { Box, Button, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { useTranslation } from 'helpers/languages/translations';
import { useTabNavigate } from 'router/tabsMapper';

import PageHeader from 'layout/pageHeader';
import { ArrowUpIcon } from '@chakra-ui/icons';
import SectoViewer from './SectoViewer';

const PATH = 'sectorisation';
const ID = 'cdm_sectorisation';
const NAME = 'page.sectorisation';

const Sectorisation = () => {
    const translate = useTranslation();
    const navigate = useNavigate();
    const { tabIndex, setTabIndex } = useTabNavigate('sectorisation');

    const renderTabs = () => (
        <Tabs isLazy onChange={(index) => setTabIndex(index)} index={tabIndex}>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>Datafield</Tab>
                <Tab _focus={{ boxshadow: 'none' }}>Dashboard</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <SectoViewer toolId={2} />
                </TabPanel>
                <TabPanel>
                    <SectoViewer toolId={1} />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'secto' }} pageTitle={translate('page.sectorisation') as string}>
                <Button
                    onClick={() => {
                        navigate('./upload');
                    }}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                >
                    {translate('users.upload.users')}
                </Button>
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { PATH, ID, NAME };
export default Sectorisation;
